// Arquetipos de instalación textil — tomados de las 8 instalaciones demo de
// la especificación (hoja 14 "Datos demo" / FACTORIES del prototipo). Lista
// de sugerencias editable (allowAdditions en el formulario), no un enum
// cerrado: cada planta real puede no calzar exactamente en una de estas.
export const INSTALLATION_ARCHETYPES = [
  "Fábrica de tela con procesos húmedos",
  "Fábrica de tela sin procesos húmedos",
  "Fábrica de tela denim con lavandería de prenda (húmedo)",
  "Hilatura + confección — vertical fibra a prenda",
  "Componentes y etiquetas + embellecimiento",
  "Producto terminado con procesos húmedos",
  "Producto terminado sin procesos húmedos",
  "Solo embellecimiento (serigrafía, sublimación, DTG, bordado)",
];
